import * as Sentry from '@sentry/react';

// Inicialização condicional: sem DSN, vira no-op silencioso (não quebra dev local).
// DSN vem do env do Vite — em prod é injetado no build via pipeline.
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Não captura input/text por padrão — evita vazar PII em forms
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Ruído não-acionável: erros de rede transitórios. O ClerkJS dispara
    // "Network error" em requests de fundo (touch de sessão, etc.) quando a
    // conexão oscila ou o request é abortado por navegação/reload — não é bug
    // do app e não dá pra tratar. Erros genéricos de fetch abortado/offline idem.
    ignoreErrors: [
      /ClerkJS:\s*Network error/i,
      'NetworkError when attempting to fetch resource.',
      'TypeError: NetworkError when attempting to fetch resource.',
      'Failed to fetch',
      'TypeError: Failed to fetch',
      'Load failed',
      // Bundle desatualizado após deploy: import() de rota lazy aponta pra chunk
      // que já sumiu. O app recarrega sozinho (ver index.jsx) — não é bug.
      /dynamically imported module/i,
      /Importing a module script failed/i,
    ],
    // 10% das transações pra performance — barato, dá visibilidade sem inflar quota.
    tracesSampleRate: 0.1,
    // Replay só em sessões com erro — sessão inteira só quando o usuário viu falha.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Re-export pra uso em ErrorBoundary etc.
export { Sentry };
